{
	"title": "Transaktionsverlauf der {{productName}}",
	"item": {
		"time": "Zeit",
		"description": "Beschreibung",
		"transactionId": "Transaktions-ID",
		"showIds": "IDs anzeigen",
		"depositTitle": "Versicherung durch DNV, ermöglicht eine Kohlenstoffbank-Einlage",
		"depositDescription": "Sobald die unabhängige Zertifizierungsstelle 'DNV' das gespeicherte abgeschiedene Kohlenstoffvolumen in einem digitalen Monitor-Report-Verify-System zertifiziert hat, wird eine neue Einlage in der Kohlenstoffbank vorgenommen.",
		"withdrawalTitle": "Rechnung an den Lieferanten, Auslösung einer Kohlenstoffbank-Abhebung",
		"withdrawalDescription": "Mit der Rechnungsstellung des evoZero-Materials an den Lieferanten wurde eine Abhebung von der Kohlenstoffbank durchgeführt.",
		"transferTitle": "Übertragung der Kohlenstoffminderungen an den Erklärungsinhaber",
		"transferDescription": "Der Lieferant hat die Übertragung der Kohlenstoffminderungen an den Erklärungsinhaber initiiert, basierend auf dem evoZero-Materialvolumen, das in das gelieferte Produkt eingeflossen ist."
	},
	"proofIdsModal": {
		"titleTransactions": "Transaktionen anzeigen",
		"titleMeasurements": "Messungen anzeigen",
		"paragraph1": "Ein Transaktionsschritt in der {{productName}} umfasst die Aggregation von Transaktionen im verteilten Hauptbuch. Unten finden Sie eine Liste von Links zu Drittanbieterdiensten, auf denen Sie diese Transaktionen anzeigen können.",
		"paragraph2": "Bitte beachten Sie, dass diese Links Sie zu externen Websites führen, die Transaktionsanzeigefunktionen bieten.",
		"open": "Öffnen",
		"close": "Schließen"
	},
	"errors": {
		"fetch": "Aktivitätsverlauf konnte nicht abgerufen werden"
	}
}
